import React, { FC } from 'react';
import { IconProps } from '.';

export const FlagIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...sizing} {...props}>
            <path d="M4.5 20.5001V3.49805" stroke="#223944" strokeLinecap="round" />
            <path
                d="M4.5 3.5865C4.5 3.5865 6.3612 3.34375 8.59895 3.78223C10.8367 4.22072 11.8353 5.28256 13.2313 5.91973C14.6274 6.5569 15.2383 6.5412 16.7762 6.46783C18.3462 6.39292 20.5 5.3429 20.5 5.3429L16.924 11.2774L20.5 15.5"
                stroke="url(#paint0_linear_1159_3092)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.5 14.0864C4.5 14.0864 6.3612 13.8439 8.59895 14.282C10.8367 14.72 11.8353 15.7808 13.2313 16.4174C14.6274 17.0539 15.2383 17.0382 16.7762 16.9649C18.3462 16.8901 20.1969 16.0202 20.5 15.8411"
                stroke="url(#paint1_linear_1159_3092)"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1159_3092"
                    x1="30.6782"
                    y1="25.1837"
                    x2="28.1105"
                    y2="7.53537"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#223944" stopOpacity="0" />
                    <stop offset="1" stopColor="#223944" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1159_3092"
                    x1="29.5936"
                    y1="19.0629"
                    x2="29.4329"
                    y2="14.9245"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#223944" stopOpacity="0" />
                    <stop offset="1" stopColor="#223944" />
                </linearGradient>
            </defs>
        </svg>
    );
};
